import React from 'react';
import { Routes, Route } from 'react-router';
import { useLocalStorageState } from 'ahooks';
import { AccountPersistInfo } from 'Internal.CommonAPI';
import withWaitingComponent from 'Common/HOC/withWaitingComponent';
import ErrorBoundary from 'Common/pages/error';

const AppsManagementScreen = React.lazy(
  () =>
    import(
      /* webpackChunkName: "appsManagementModule" */
      'AppsManagement/screens/Apps'
    )
);

const AppsRouter = () => {
  const [account] = useLocalStorageState<AccountPersistInfo>('account');
  return (
    <>
      {account !== undefined && (
        <Routes>
          <Route
            path=""
            element={
              account.isActive ? (
                withWaitingComponent(AppsManagementScreen)
              ) : (
                <ErrorBoundary />
              )
            }
          />
          <Route path="*" element={<ErrorBoundary />} />
        </Routes>
      )}
    </>
  );
};

export default AppsRouter;
